import "flowbite-react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode's dev-only double-invoke of mount/unmount is incompatible with
  // @react-google-maps/api's Marker — it creates the marker, tears it down, and then
  // silently fails to re-attach it (no console error), which is why map pins were
  // going missing only in `npm start`, never in a production build.
  <App />
);
reportWebVitals();
